import { apiClient } from './api';
import { 
  Call,
  CallDetailResponse,
  CallsQueryParams
} from '../types';

export const callsApi = {
  // Get paginated list of calls for authenticated user
  getCalls: async (params?: CallsQueryParams): Promise<Call[]> => {
    return apiClient.get<Call[]>('/api/calls', params);
  },

  // Get specific call details with messages/transcript
  getCall: async (callId: string): Promise<CallDetailResponse> => {
    return apiClient.get<CallDetailResponse>(`/api/calls/${callId}`);
  },
};